import { get } from 'utils/axios';
import { GetListingsV3FeaturedPublicResponseSchema } from '@kouto/types';
import z from 'zod';

type GetFeaturedListingsV3Response = z.infer<
  typeof GetListingsV3FeaturedPublicResponseSchema
>;

const getFeaturedListingsV3 = async (url: string) => {
  const response = await get<{ data: GetFeaturedListingsV3Response }>(url);
  return response.data;
};

export default getFeaturedListingsV3;
